export interface CollapsibleItem {
  title: string;
  content: string;
}

export const advancedOrderbookFeatures: CollapsibleItem[] = [
  {
    title: 'Right Click for Advanced Analysis',
    content:
      'Klik kanan pada harga untuk menganalisa berbagai macam fitur terkini.',
  },
  {
    title: 'Buy From Orderbook',
    content:
      'Beli saham langsung di orderbook dan dot warna hijau akan muncul sebagai status order yang kamu buat.',
  },
  {
    title: 'Drag to Sell',
    content:
      'Kini menjual seluruh saham di portfolio bisa dengan cara drag Available Lot pada bagian atas ke harga yang diinginkan.',
  },
];

export const valueIcons = [
  {
    icon: '/images/value-1.svg',
    text: ['Aplikasi Stabil', <br />, 'dan Ringan'],
  },
  { icon: '/images/value-2.svg', text: ['Ultra Fast', <br />, ' Order 10ms'] },
  { icon: '/images/value-3.svg', text: ['Data', <br />, 'Real Time'] },
];

export const valuePoint = [
  {
    text: 'Complete Widget',
    subText:
      'Buat sendiri trading layout sesuai preferensi kamu dengan pilihan widget yang lengkap.',
  },
  {
    text: 'Customizable Layout',
    subText:
      'Add, remove, resize, atur posisi bahkan grouping widget sesuka kamu.',
  },
  {
    text: 'Autosave in Cloud',
    subText:
      'Bahkan jika kamu mengganti device, trading layout yang kamu buat tetap bisa diakses.',
  },
];

export const faq = [
  {
    title: 'Bagaimana cara download aplikasi Stockbit versi desktop?',
    content:
      'Caranya dengan menekan salah satu tombol download untuk Mac atau Windows sesuai OS yang kamu miliki. Setelah instalasi, kamu dapat login akun Stockbit ataupun mendaftarkan sebagai user baru.',
  },
  {
    title: 'Apakah aplikasi Stockbit versi desktop berbayar?',
    content:
      'Akses aplikasi saham Stockbit versi desktop bisa digunakan secara gratis. Kamu hanya perlu log-in atau mendaftarkan akun di Stockbit.',
  },
  {
    title: 'Apakah tetap bisa trading saham di Stockbit versi desktop?',
    content:
      'Ya, kamu tetap bisa trading lebih mudah dengan layar yang lebih luas di aplikasi Stockbit versi Desktop untuk Mac dan Windows.',
  },
];

export const schemaJson = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Aplikasi Saham Stockbit versi Desktop untuk MacOs dan Windows',
  description:
    'Aplikasi investasi saham dengan tampilan layar yang lebih luas untuk kemudahan saat trading atau beli saham.',
  publisher: {
    '@type': 'Organization',
    name: 'Stockbit',
  },
};

export const keyword =
  'aplikasi saham, aplikasi trading saham, aplikasi saham desktop, aplikasi saham windows, aplikasi saham macOS, aplikasi saham macbook, aplikasi saham online, aplikasi investasi desktop saham, download aplikasi saham desktop, aplikasi investasi saham terbaik, aplikasi saham aman.';

export const metaDesc =
  'Aplikasi saham dengan tampilan multi monitor untuk mendukung performa trading sahammu. Stockbit tersedia desktop app untuk Windows dan MacOs. Download sekarang!';

export const metaTitle =
  'Download Aplikasi Saham Stockbit Desktop App untuk Mac dan Windows';

export type DownloadSDASource =
  | 'Download Page'
  | 'Dropdown Profile'
  | 'Stockbit Main Page'
  | 'Trading Setup Page';

export type SDAOS = 'Mac' | 'Windows';

export const systemRequirement = {
  windows: [
    {
      key: 'OS',
      value: 'Windows 10 or above (64 bit)',
    },
    {
      key: 'Processor',
      value: 'Dual core from Intel or AMD at 2.8 GHz',
    },
    {
      key: 'Memory',
      value: '16GB RAM',
    },
    {
      key: 'Storage',
      value: '20GB available space',
    },
  ],
  mac: [
    {
      key: 'OS',
      value: 'MacOS 12 or above',
    },
    {
      key: 'Processor',
      value: 'Apple M1 or Intel Core M',
    },
    {
      key: 'Memory',
      value: '8GB RAM',
    },
    {
      key: 'Storage',
      value: '20GB available space',
    },
  ],
};
